import React from "react";

import { Grid, Typography } from "@mui/material";

import Logo from "../images/logo.svg";
import { StyledFooterWrapper, Box1400, FooterRightWrapper } from "./styles";

// import { footer } from "../data/global";
import { useStaticQuery, graphql } from "gatsby";

const getData = graphql`
  query {
    site {
      siteMetadata {
        title
        address
        email
        phone
        copyRight
      }
    }
  }
`;
const Footer = () => {
  const { site } = useStaticQuery(getData);
  const { siteMetadata } = site;
  const textLeft = [
    siteMetadata.address,
    siteMetadata.phone,
    siteMetadata.email,
  ];
  const textRight = ["Privacy Policy", "Terms of use", siteMetadata.copyRight];
  return (
    <StyledFooterWrapper>
      <Box1400>
        <Grid container>
          <Grid item xs={12} sm={6}>
            <img src={Logo} alt="logo" />
            {textLeft.map((text, i) => {
              return (
                <Typography
                  variant="body2"
                  color="white60.main"
                  key={`footer-left-${i}`}
                >
                  {text}
                </Typography>
              );
            })}
          </Grid>
          <Grid item xs={12} sm={6}>
            <FooterRightWrapper>
              {textRight.map((text, i) => {
                return (
                  <Typography
                    variant="body2"
                    color="white60.main"
                    key={`footer-right-${i}`}
                  >
                    {text}
                  </Typography>
                );
              })}
            </FooterRightWrapper>
          </Grid>
        </Grid>
      </Box1400>
    </StyledFooterWrapper>
  );
};

export default Footer;
